import { Moment } from 'moment'

import { Person } from '../../../App/store/features/person/IPerson'
import { findPersonUuid } from '../../EventCrudPanel/Appointment/UpdateAppointment/utils/findUuid/findPersonUuid'
import { IEvent, IEventCoordinates, IUpdateBlockData } from '../../types'

import { updateColumnCalculation } from './updateColumnCalculation'

export const updateBlockMoment = (
  eventCoordinates: IEventCoordinates,
  event: IEvent,
  filteredPersons: Person[],
  blockCategoryUuid: string,
): IUpdateBlockData => {
  const {
    eventNewColumnNumber,
    eventNewY,
    eventPixelHeight,
    pixelsPerHour,
    selectedStartDate,
  } = eventCoordinates

  const { personArrayPosition, droppedDayNumber } = updateColumnCalculation(
    eventNewColumnNumber,
    filteredPersons.length,
  )

  const personUuid = findPersonUuid(
    filteredPersons,
    filteredPersons[personArrayPosition].id,
  )

  const droppedAtMinutes: number = (eventNewY / pixelsPerHour) * 60
  const eventDuration: number = (eventPixelHeight / pixelsPerHour) * 60
  const resetStartAt: Moment = selectedStartDate.clone().set({ h: 0, m: 0 })
  const updatedEventStartAt: Moment = resetStartAt
    .clone()
    .add(droppedDayNumber - 1, 'days')
    .add(droppedAtMinutes, 'minutes')

  return {
    blockedCategoryUuid: blockCategoryUuid,
    personUuid,
    startsAt: updatedEventStartAt,
    endsAt: updatedEventStartAt.clone().add(eventDuration, 'minutes'),
    notes: event.text || '',
  }
}
